export const apiPaths = {
  register: '/auth/register',
  login: '/auth/login',
  loginTotp: '/auth/login/totp',
  loginRecoveryCode: '/auth/login/recovery-code',
  refresh: '/auth/refresh',
  logout: '/auth/logout',
  twoFactorEnrol: '/auth/2fa/enrol',
  twoFactorActivate: '/auth/2fa/activate',
  twoFactorDisable: '/auth/2fa',
  partnerProfile: '/partner/me',
  terms: '/terms',
  termsAcceptance: '/terms/acceptance',
  sdk: '/sdk',
  sdkReleases: '/sdk/releases',
  sdkAssetLink: '/sdk/assets/:assetId/link',
  faq: '/faq',
  faqCases: '/faq/cases',
  agentCountrySummary: '/agents/summary/countries',
  trafficSeries: '/statistics/traffic',
  trafficCountries: '/statistics/traffic/countries',
  moderationSubmissions: '/moderation/submissions',
  moderationSubmission: '/moderation/submissions/:submissionId',
  pluginBuilds: '/plugin/builds',
  pluginBuild: '/plugin/builds/:buildId',
  pluginBuildDownload: '/plugin/builds/:buildId/download',
  pluginViewer: '/plugin/viewer',
} as const

export type ApiPathName = keyof typeof apiPaths

export const withPathParams = (path: string, params: Record<string, string | number>): string =>
  Object.entries(params).reduce(
    (result, [name, value]) => result.replace(`:${name}`, encodeURIComponent(String(value))),
    path,
  )
